/**
 * Envisioning Card
 * Displays business and personal envisioning links
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';

const EnvisioningCard = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const canViewBusiness = hasPermission('can_view_business_envisioning');
  const canViewPersonal = hasPermission('can_view_personal_envisioning');

  // If no permissions at all, don't show the card
  if (!canViewBusiness && !canViewPersonal) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-rose-600 to-pink-600 p-4 text-white">
        <div className="flex items-center space-x-3">
          <Sparkles size={24} />
          <div>
            <h3 className="text-lg font-bold">Envisioning</h3>
            <p className="text-xs text-rose-100">Business & Personal</p>
          </div>
        </div>
      </div>
      <div className="p-4 space-y-3">
        {/* Business Envisioning */}
        {canViewBusiness && (
          <div className="border-b border-gray-200 pb-3">
            <p className="text-xs font-semibold text-gray-600 mb-2">BUSINESS</p>
            <p className="text-sm text-gray-600 mb-3">
              Clarify your 3–10 year vision for business growth and exit strategy
            </p>
          </div>
        )}

        {/* Personal Envisioning */}
        {canViewPersonal && (
          <div className={canViewBusiness ? "pb-2" : "border-b border-gray-200 pb-3"}>
            <p className="text-xs font-semibold text-gray-600 mb-2">PERSONAL</p>
            <p className="text-sm text-gray-600 mb-3">
              Define your personal vision and life goals beyond business exit
            </p>
          </div>
        )}

        {/* Spacer to align buttons with other widgets */}
        <div className="h-2"></div>

        {/* View Envisioning Buttons */}
        <div className={`grid ${canViewBusiness && canViewPersonal ? 'grid-cols-2' : 'grid-cols-1'} gap-2`}>
          {canViewBusiness && (
            <button
              onClick={() => navigate('/envisioning?tab=business')}
              className="px-3 py-2.5 bg-rose-600 text-white rounded-lg hover:bg-rose-700 font-semibold transition text-xs"
            >
              Business
            </button>
          )}
          {canViewPersonal && (
            <button
              onClick={() => navigate('/envisioning?tab=personal')}
              className="px-3 py-2.5 bg-pink-600 text-white rounded-lg hover:bg-pink-700 font-semibold transition text-xs"
            >
              Personal
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnvisioningCard;
